module.exports = __webpack_public_path__ + "static/18(2)-8a7e8d0de8d10f68a9c4a0fc95e13a9d.jpg";